module.exports = __webpack_public_path__ + "img/sin-imagen.19275c54.jpg";